<div class="extended-input-wrapper">
    <ng-content></ng-content>
    <small *ngIf="inputUnderNote" class="input-under-comment">* {{inputUnderNote}}</small>
    <div class="input-error-wrapper px-2 pb-2" *ngIf="isShowErrors()">
        <small class="error-message">{{getRelevantErrorMessage() | translate}}</small>
        <small class="error-message" *ngIf="additionalValidationParam">{{additionalValidationParam}}</small>
    </div>
</div>
